import {bytesToBase64} from '../../../../../helper/base64';
import File from "../model/File";

class FileManager {

    constructor() {
    }

    fromText(filename, type, text) {
        let file = new File();

        const base64Text = bytesToBase64(new TextEncoder().encode(text));

        file.content = `data:text/plain;base64,${base64Text}`;
        file.options.type = type;
        file.filename = filename;

        return file;
    }

    fromImage(filename, type, base64image) {
        let file = new File();

        file.content = base64image;
        file.options.type = type;
        file.filename = filename;

        return file;
    }
}

export default new FileManager()